/**
 * React Query hook for fallacy analysis
 * Simple mutation wrapper around edge functions
 */

import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { analyzeFallacies, generateFlippedApproach } from '@/services/ai/fallacyAnalysis';

export function useFallacyAnalysis() {
  const analyzeText = useMutation({
    mutationFn: analyzeFallacies,
    onSuccess: () => {
      toast.success('Analysis completed!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Analysis failed. Please try again.');
    },
  });

  const generateFlipped = useMutation({
    mutationFn: generateFlippedApproach,
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to generate flipped approach. Please try again.');
    },
  });

  return {
    analyzeText,
    generateFlippedApproach: generateFlipped,
  };
}
